module.exports = function(app) {
    app.directive('ssnNoZeroValidation', ["$window", "$compile", function($window, $compile) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, elem, attrs, ctrl) {

                //changes for RF1240502 , removed the hyphen - in the below link function.
                elem.attr('placeholder', '_________');
                elem.attr('maxlength', '9');

                var temp = '';
                var regxa = /^(\d{3}-?\d{2}-?\d{4})$/;
                elem.focusin(function(){
                    if (temp.length) {
                        var formatted = temp.slice(0, 3) + temp.slice(3, 5) + temp.slice(5, 9);
                        elem.val(formatted);
                    }
                });

                elem.on('blur',function(){
                    temp = elem.val().replace(/[^0-9]/g, '');
                    if(regxa.test(elem.val())){
                        if (temp.length === 9) {
                            elem.val("*****" + temp.slice(5));
                        }
                    }
                });

                ctrl.$parsers.push(function (value) {
                    if (value) {
                        value = value.replace(/[^0-9]/g, '');

                        return value;
                    } //changes for RF1240502 , else block to pass null value to ctrl.$validators, when there is no value in SSN entered.
                    else if(value == '' || value == undefined){
                        return null;
                    }
                });
               
                ctrl.$validators.ssnNoZeroValidation = function (modelValue, viewValue) {
                    //changes for RF1240502 , where validation is not happeing for SSN should be 9 charecters.
                    if(modelValue && modelValue !== undefined)// if we have model value then check for length
                    {
                        return ((modelValue != '000000000') && modelValue.length == 9);
                    }
                    else { //if we dont have any modelvalue - for dependents it is not mandatory
                        return (modelValue != '000000000') && (viewValue ? (/^\d{9}$/.test(modelValue)): true) ;//when we have only alphabets we need to check viewvalue
                    }

                };
            }
        };
    }]);
};
[]